module.exports = __webpack_public_path__ + "static/media/5.1b557aa7.jpg";